/**
 * @generated SignedSource<<09a246585aeb9d8b6d33e5085648b5fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectoryLocationFilter_viewer$data = {
  readonly regions: ReadonlyArray<{
    readonly code: string | null;
    readonly regionName: string | null;
  } | null> | null;
  readonly " $fragmentType": "DesignerDirectoryLocationFilter_viewer";
};
export type DesignerDirectoryLocationFilter_viewer$key = {
  readonly " $data"?: DesignerDirectoryLocationFilter_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryLocationFilter_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectoryLocationFilter_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "regionType",
          "value": "TRADE_FIRM_REGION"
        }
      ],
      "concreteType": "Region",
      "kind": "LinkedField",
      "name": "regions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "regionName",
          "storageKey": null
        }
      ],
      "storageKey": "regions(regionType:\"TRADE_FIRM_REGION\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1a45551a7c1093ccd600fd5a8f8b4469";

export default node;
